import React, { useState } from 'react'
import './EditItemListComponent.css'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import displayDate from "../../../Utilities/displayDate";


export default function EditItemListComponent(props) {

    const [name, setName] = useState(props.item.name)
    const [qty, setQty] = useState(props.item.quantity)
    const [comment, setComment] = useState(props.item.comment)

    const onAcceptButtonClick = () => {

        if (name !== "" && qty >= 1) {
            let newItem = {
                ...props.item,
                name: name,
                quantity: parseInt(qty),
                comment: comment
            }
            props.onEditInventoryItem(newItem)
            props.onEditButtonClick()
            console.log("ok updated item")
        } else if (name === "") {
            console.log("Please enter the name of the item")
        } else if (qty < 1) {
            console.log("Quantity must be more than 0")
        }
    }

    return (
        <div className="ListItem">
            <div className="container col-5 listCell" >
                <TextField
                    className="editInput"
                    required
                    id="outlined-name-input"
                    onChange={(e) => setName(e.target.value)}
                    type="name"
                    name="name"
                    margin="normal"
                    value={name}
                    variant="standard"
                />
            </div>
            <div className="container col-1 listCell" >
                <TextField
                    className="editInput"
                    id="outlined-qty-input"
                    inputProps={{ min: "1", max: "20", step: "1" }}
                    onChange={(e) => setQty(e.target.value)}
                    type="number"
                    name="quantity"
                    margin="normal"
                    value={qty}
                    variant="standard"
                    style={{ width: 30 }}
                />
            </div>
            <div className="container col-2 listDate listEditDate" >{displayDate(props.item.dates[0])}</div>
            <div className="container col-2 listCell d-none d-sm-block" >
                <TextField
                    required
                    id="outlined-name-input"
                    onChange={(e) => setComment(e.target.value)}
                    type="name"
                    name="name"
                    margin="normal"
                    value={comment}
                    variant="standard"
                />
            </div>
            <div className="container col-2 listBtn">
                <Button id="acceptItemButton" onClick={() => onAcceptButtonClick()}> <img className="acceptIcon" src={require('../../../Images/Icons/yes.svg')} alt="acceptIcon"></img> </Button>
            </div>
        </div >
    )
}
